<!-- Интеграции -->
<template>
  <li
    v-if="canSeePage('integrations')"
    class="nav-item integrations__link"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Integrations')"
    @mouseup="handleMiddleClick($event, 'Integrations')"
    @contextmenu.prevent.stop="
      showContextMenu($event, 'Integrations')
    "
    :class="{ active: activeItem === 'integrations' }"
    :title="collapsed ? 'Интеграции' : ''"
  >
    <div class="link-icon_box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="integrations-svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
        />
      </svg>
    </div>
    <AppSidebarItemLabel
      label="Интеграции"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "IntegrationsItem",
  components: { AppSidebarItemLabel },
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
